/** A country's chart colors: `fill` for shapes, bars and bubble borders, `text` for numbers on white. */
export interface CountryColor {
  fill: string;
  text: string;
}

// From the XD (Portada PM). Final palette pending the client (task D6).
const COUNTRY_COLORS: Record<string, CountryColor> = {
  AR: { fill: '#8BD2EA', text: '#59AAC6' },
  BR: { fill: '#1FB151', text: '#1FB151' },
  CL: { fill: '#F45E53', text: '#CE221C' },
  PY: { fill: '#6C7196', text: '#6C7196' }
};

export const OTHER_COUNTRY: CountryColor = { fill: '#ADADAD', text: '#707070' };

/** The colors of a country by ISO code (`code` in the API); gray for the rest. */
export const countryColor = (code?: string | null): CountryColor =>
  (code && COUNTRY_COLORS[code]) || OTHER_COUNTRY;
